var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('Header'),_c('router-view'),_c('Footer')],1),_c('navigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }